import React from "react";
import Modal from "react-bootstrap/Modal";

const DeleteSubfile = (props) => {
  return (
    <Modal
      className="subfile-modal"
      size="md"
      centered
      show={props.showSubfileDeleteModal}
      onHide={props.subfileDeleteCloseHandler}
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
    >
      <div role="document" className="modal-md">
        <div className="modal-header  border-0 is-size-h4 bold">Delete Sub-File</div>
        <div className="modal-body">
          <div className="is-size-body-1 d-flex">
            Are you sure you want to delete this sub-file?
          </div>
        </div>
        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn-secondary"
            onClick={props.subfileDeleteCloseHandler}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-danger-filled"
            onClick={() => {
              props.subfileDeleteHandler(props.id);
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteSubfile;
